export const name = '@lifi/widget'
export const version = '3.25.0-beta.5'
